import { Outlet } from 'react-router-dom';
import LinkTabs from '../../../shared/components/LinkTabs/LinkTabs';
import BlacklistHeader from './BlacklistHeader/BlacklistHeader';
import { BlacklistManagementProvider } from '../context/BlacklistManagement';

export const blacklistTabs = [
  {
    label: 'Channel Wise',
    path: '/settings/blacklist',
  },
  {
    label: 'Loyalty / Sms',
    path: '/settings/blacklist/loyalty',
  },
  {
    label: 'Webhook Manager',
    path: '/settings/blacklist/webhooks',
  },
];

const BlacklistContainer = () => {
  return (
   <BlacklistManagementProvider>
      <BlacklistHeader />
      <LinkTabs settingsTabs={blacklistTabs} />
      <Outlet />
   </BlacklistManagementProvider>
  );
};

export default BlacklistContainer;
